<div class="container-fluid mb-5 px-3">
    @if (loadingPolicies) {
        <div class="spinner-container d-flex justify-content-center align-items-center">
            <mat-spinner></mat-spinner>
        </div>
    } @else {
        <div class="mt-3 d-flex justify-content-between">
            <div class="font-weight-bold">
                <h1>
                    <span *ngIf="this.selectedOrganizationName">
                        {{ this.selectedOrganizationName }}
                    </span>
                    Reservations
                </h1>
            </div>
            <div class="d-flex mt-2 me-1">
                <button mat-raised-button class="action-button d-flex col-auto align-items-center" style="margin-right:8px;"
                (click)="onCreateReservationClick()">
                    <mat-icon>add</mat-icon>
                    Create Reservation
                </button>
                <button mat-raised-button class="action-button d-flex col-auto align-items-center" (click)="onImportReservationDataClick()">
                    <mat-icon>add</mat-icon>
                    Import From Excel
                </button>
            </div>
        </div>
    }
    <mat-card appearance="outlined" class="mt-3 pb-5">
        <div class="row justify-content-center">
            <div class="col-12">
                <app-data-table
                    [component]="'Reservations'"
                    (searchEvent)="onSearchEvent($event)"
                    (pageEvent)="onPageEvent($event)"
                    (sortEvent)="onSortEvent($event)"
                    [dataSource]="dataSource"
                    [displayedColumns]="displayedColumns"
                    [tableLength]="tableLength"
                    [pageSize]="pageSize"
                    [pageNumber]="pageNumber"
                    [showPaginator]="true"
                    [filterDefinitions]="filterDefinitions"
                    [displayLoadingIndicator]="loading"
                    [getCalculatedActionButtonText]="getActionButtonText.bind(this)"
                    [getActionButtonColor]="getNewClaimButtonBackgroundColor.bind(this)"
                    [getActionButtonIcon]="getActionButtonIcon.bind(this)"
                    (actionClickedEvent)="onReservationActionClick($event)"
                    [getStatusColor]="getReservationStatusColor"
                    [initialPageSize]="this.initialPageSize"
                    [initialPageNumber]="this.initialPageNumber"
                    [initialKeyword]="this.initialKeyword"
                    [initialSort]="this.initialSort"
                    (massUpdateReservationPolicyEvent)="onReservationUpdatePolicyEvent($event)"
                    (massUpdateReservationStatusEvent)="onReservationUpdateStatusEvent($event)"
                >
                </app-data-table>
            </div>
        </div>
    </mat-card>
</div>